import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactFormAndDetails from "./sections/ContactFormAndDetails";
import ScheduleAConsultation from "./sections/ScheduleAConsultation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Hero />
      <ContactFormAndDetails />
      <ScheduleAConsultation />
      <Footer />
    </div>;
}